import { normalizeContactPhone } from "@/modules/common/utils/customer-contact";
import { Box } from "@mui/material";
import Call from "@/assets/icons/lead-page/call";
import useLeadContactMethods from "@/modules/lead-page/hooks/lead-info/lead-contact-methods.hook";
import { handleContactPhone } from "@/modules/common/utils";

const ContactPhone = ({ phoneNumber }: { phoneNumber: string | undefined }) => {
  const { handleStartCall, isLoading } = useLeadContactMethods();

  const handleClick = async () => {
    if (isLoading || !normalizeContactPhone(phoneNumber)) return;
    await handleStartCall();
    handleContactPhone(phoneNumber);
  };

  return (
    <Box
      sx={{
        cursor: isLoading ? "not-allowed" : "pointer",
        opacity: isLoading ? 0.6 : 1,
      }}
      onClick={handleClick}
    > 
      <Call />
    </Box>
  );
};

export default ContactPhone;
